<html>
<nav *ngIf="isAuth" class="navbar fixed-top navbar-expand-sm navbar-dark bg-dark ">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    <img src="./assets/images/Logo_Transparent.png" class="header-logo">
    <div class="collapse navbar-collapse " id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a class="nav-link" href="#" (click)="toggleMain();">Today's Info</a>
            </li>
            <!--
            <li class="nav-item">
                <a class="nav-link" href="#" (click)="toggleTime();">Current Snapshot</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#" (click)="toggleTime();">Time Admin</a>
            </li>
        -->
            <li class="nav-item">
                <a class="nav-link" href="#" (click)="logOut();">Log Out</a>
            </li>
        </ul>
    </div>
</nav>

<body>
    <div class="row">

        <!--  <div class="col-sm-2">
        <div class="list-group">
        <button type="button" (click)="toggleTime();" class="list-group-item list-group-item-action">Daily
            Activity</button>
        <button type="button" (click)="toggleTime();" class="list-group-item list-group-item-action">Time Admin</button>

        </div>
    </div>-->
        <div class="col-sm-12">
            <app-login *ngIf="!isAuth"></app-login>
            <app-main-view *ngIf="showMain"></app-main-view>
            <app-time-admin *ngIf="showTime"></app-time-admin>
            <app-current-snapshot *ngIf="showSnapshot"></app-current-snapshot>

        </div>
    </div>
</body>

</html>